import React, { useState } from 'react';
import { wt } from './widgetTokens';

interface HelpTooltipProps {
  helpText: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({ helpText }) => {
  const [visible, setVisible] = useState(false);

  if (!helpText) return null;

  return (
    <div className={wt.tooltipWrap}>
      <button
        type="button"
        className={wt.tooltipTrigger}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onFocus={() => setVisible(true)}
        onBlur={() => setVisible(false)}
        aria-label="Help information"
      >
        ?
      </button>
      {visible && (
        <div className={wt.tooltipBox}>
          {helpText}
        </div>
      )}
    </div>
  );
};

export default HelpTooltip;
